import { KeysResponse } from "./keys.response";

export class OrganizationKeysResponse extends KeysResponse {
  constructor(response: any) {
    super(response);
  }
}
